export default __webpack_public_path__ + "static/Screenshot5-81bfdd84bdc0f6860dabe109d8b12c84.jpg";